<template>
  <section class="cx-sec">
    <router-link-localed
      to="/barrier-free-access-guide"
    >Accessibility</router-link-localed>
  </section>
</template>

<script>
export default {
  name: 'home-accessibility'
}
</script>